document.addEventListener('DOMContentLoaded', function () {
  // Setup
  const sectionSelector = '.venue-archive-container';
  const resultsSelector = '.venue-archive-results';
  const eyebrowSelector = '.venue-archive-heading-eyebrow';
  const titleSelector = '.venue-archive-heading-title';

  // Start
  const section = document.querySelector(sectionSelector);
  const results = section?.querySelector(resultsSelector);

  if (!section || !results) return;
  
  const replaceTitle = !!parseInt(section.dataset.replaceTitleByLocation, 10);
  const eyebrow = section.querySelector(eyebrowSelector);
  const title = section.querySelector(titleSelector);
  const originalEyebrow = eyebrow?.innerHTML;
  const originalTitle = title?.innerHTML;

  const filterResults = () => {
    const url = new URL(window.location.href);
    const selectedCountry = url.searchParams.get('country');
    const selectedProvince = url.searchParams.get('province');
    const locations = get_locations();
    let countryName = null;
    let provinceName = null;
    
    results.querySelectorAll('article').forEach((venue) => {
      venue.classList.remove('hidden!');

      const venueCountry = locations[venue.dataset.country];
      const venueProvince = venueCountry?.children?.[venue.dataset.province];

      const venueCountrySlug = venueCountry?.slug;
      const venueProvinceSlug = venueProvince?.slug;

      const venueInfo = get_venue_info(venue.dataset.venue);
      
      if(get_is_happy_hour_at_venue(venueInfo)){
        venue.querySelector('.happy-hour').classList.remove('hidden');
      }else{
        venue.querySelector('.happy-hour').classList.add('hidden');
      }

      if((selectedCountry || selectedProvince) && (selectedCountry != venueCountrySlug) && (selectedProvince != venueProvinceSlug)){
        venue.classList.add('hidden!');
      }else{
        countryName = venueCountry?.name;
        provinceName = venueProvince?.name;
      }
    });

    if(replaceTitle){
      if(selectedProvince){
        eyebrow.innerHTML = countryName;
        title.innerHTML = provinceName;
      }else if(selectedCountry){
        eyebrow.innerHTML = originalEyebrow;
        title.innerHTML = countryName;
      }else{
        eyebrow.innerHTML = originalEyebrow;
        title.innerHTML = originalTitle;
      }
    }
  }
  filterResults();

  window.addEventListener('LocationSelectorStateChanged', filterResults);
  window.addEventListener('popstate', filterResults);
});